import { render, staticRenderFns } from "./DashboardAgentsCard.vue?vue&type=template&id=558fe660&"
import script from "./DashboardAgentsCard.vue?vue&type=script&lang=js&"
export * from "./DashboardAgentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports